import { Bell } from "lucide-react";

interface NotificationBellProps {
  count?: number;
}

export function NotificationBell({ count }: NotificationBellProps) {
  return (
    <button
      type="button"
      className="relative w-[38px] h-[38px] rounded-[10px] border border-sc-glass-border bg-sc-glass backdrop-blur-[10px] flex items-center justify-center text-sc-text-muted cursor-pointer hover:bg-sc-surface-hover transition-all"
      aria-label={
        count && count > 0
          ? `${count} notification${count > 1 ? "s" : ""}`
          : "No notifications"
      }
    >
      <Bell size={18} />
      {count !== null && count !== undefined && count > 0 && (
        <div className="absolute top-2 right-2 w-1.5 h-1.5 rounded-full bg-[#3cb34a] shadow-sc-glow" />
      )}
    </button>
  );
}
